var _rect, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 1.91,
    x: 4.36,
    y: 1.5,
    width: 15.27,
    height: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.91,
    d: "M11,5.32H13a2.86,2.86,0,0,1,2.86,2.86v1a0,0,0,0,1,0,0H8.18a0,0,0,0,1,0,0v-1A2.86,2.86,0,0,1,11,5.32Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.91,
    x1: 12,
    y1: 1.5,
    x2: 12,
    y2: 5.32
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.91,
    x1: 11.05,
    y1: 12,
    x2: 12.95,
    y2: 12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.91,
    x1: 14.86,
    y1: 12,
    x2: 16.77,
    y2: 12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.91,
    x1: 9.14,
    y1: 14.86,
    x2: 11.05,
    y2: 14.86
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.91,
    x1: 12.95,
    y1: 14.86,
    x2: 14.86,
    y2: 14.86
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.91,
    x1: 7.23,
    y1: 12,
    x2: 9.14,
    y2: 12
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.91,
    x1: 0.55,
    y1: 22.5,
    x2: 23.45,
    y2: 22.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.91,
    x1: 19.64,
    y1: 6.27,
    x2: 22.5,
    y2: 6.27
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.91,
    x1: 19.64,
    y1: 17.73,
    x2: 22.5,
    y2: 17.73
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/shower.d64e6f9b3f85fe1564be33cd10897670.svg";
export { ForwardRef as ReactComponent };